import { ConnectionLink } from '../model/entities';
import adminApiAxios from './CustomAxios';

class ConnectionLinkApi {
    list = async (connectionId: number): Promise<ConnectionLink[]> => {
        const response = await adminApiAxios.get<ConnectionLink[]>('/connection-links', {
            params: { connectionId },
        });

        return response.data;
    };

    get = async (id: number): Promise<ConnectionLink> => {
        const response = await adminApiAxios.get<ConnectionLink>(`/connection-links/${id}`);
        return response.data;
    };

    create = async (connectionLink: ConnectionLink): Promise<ConnectionLink> => {
        const response = await adminApiAxios.post<ConnectionLink>('/connection-links', connectionLink);
        return response.data;
    };

    update = async (connectionLink: ConnectionLink): Promise<ConnectionLink> => {
        const response = await adminApiAxios.put<ConnectionLink>(
            `/connection-links/${connectionLink.id}`,
            connectionLink,
        );
        return response.data;
    };

    delete = async (connectionLink: ConnectionLink): Promise<void> => {
        await adminApiAxios.delete(`/connection-links/${connectionLink.id}`);
    };
}

const connectionLinkApi: ConnectionLinkApi = new ConnectionLinkApi();
export default connectionLinkApi;
